import React from 'react';
import PropTypes from 'prop-types';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Divider, Typography, Box
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import useStyles from './styles';
import { createPrixPierreRevient } from './pricing';

// Reconstruit une description cohérente avec l'autocomplete si possible
const buildUnifiedDesc = (p) => {
    if (!p) return '';
    // Si descriptionPierre existe déjà et que les champs dimension ne sont pas disponibles, on retourne tel quel
    const hasDimData = p.typ_dim !== undefined;
    if (!hasDimData) return p.descriptionPierre || '';

    let description = '';
    // Structure proche de createDefaultDescPierre
    description = p.type + ' ' + p.laforme + ' ' + p.couleur + ' ';
    let poids = '', dimension = '', diametre = '';
    if (Number(p.typ_dim) === 0) {
        poids = p.dim1;
        diametre = ' Ø' + p.dim2;
        description += poids + ' ' + diametre;
    } else if (Number(p.typ_dim) === 1 || Number(p.typ_dim) === 3) {
        dimension = p.dim1 + 'x' + p.dim2;
        poids = p.dim3;
        description += dimension;
    } else if (Number(p.typ_dim) === 2) {
        dimension = p.dim1 + 'x' + p.dim2 + 'x' + p.dim3;
        description += dimension;
        poids = '';
    }
    // Ajouter qualité
    const qualPart = p.laqual ? (' ' + p.laqual) : '';
    return poids !== '' ? description + qualPart + ' = ' + poids : description + qualPart;
};

const StoneTable = ({ stones, cours, setStones, totalCarats, totalPierres, onEditStone }) => {
    const classes = useStyles();

    const handleDeleteStone = (index) => {
        setStones(prev => prev.filter((_, i) => i !== index));
    };

    return (
        <>
            <TableContainer component={Paper} style={{ marginTop: 16, overflowX: 'auto' }}>
                <Table className={classes.stoneTable} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeader}>Qté</TableCell>
                            <TableCell className={classes.tableHeader}>Description</TableCell>
                            <TableCell align='right'  className={classes.tableHeader}>Poids</TableCell>
                            <TableCell align='right'  className={classes.tableHeader}>Prix R</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {stones.map((stone, index) => {
                            const prixRevient = createPrixPierreRevient(stone, stone.lePoids, cours);
                            return (
                                <TableRow
                                    key={stone.id_pier && stone.id_qual ? `${stone.id_pier}-${stone.id_qual}-${index}` : index}
                                    className={classes.selectableRow}
                                    onClick={() => onEditStone(stone, index)}
                                >
                                    <TableCell className={classes.tableCell}>{stone.qte}</TableCell>
                                    <TableCell className={classes.tableCellDesc}>{buildUnifiedDesc(stone)}</TableCell>
                                    <TableCell align='right' className={classes.tableCell}>{stone.lePoids.toFixed(2)}</TableCell>
                                    <TableCell align='right' className={classes.tableCell}>{prixRevient.toFixed(0)} €</TableCell>
                                    <TableCell align="right" className="no-print">
                                        <IconButton
                                            onClick={(e) => { e.stopPropagation(); handleDeleteStone(index); }}
                                            className={classes.deleteButton}
                                            size="small"
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <Divider style={{ marginTop: 'auto', marginBottom: 8 }} />
            <Box className={classes.totalRow}>
                <Typography variant="h6" className={classes.totalText}>
                    TOTAL ({totalCarats.toFixed(2)} ct)
                </Typography>
                <Typography className={classes.totalPrice}>{totalPierres.toFixed(0)} €</Typography>
            </Box>
        </>
    );
};

StoneTable.propTypes = {
    stones: PropTypes.array.isRequired,
    cours: PropTypes.array.isRequired,
    setStones: PropTypes.func.isRequired,
    totalCarats: PropTypes.number.isRequired,
    totalPierres: PropTypes.number.isRequired,
    onEditStone: PropTypes.func.isRequired,
};

export default StoneTable;
